import { MRT_ColumnDef } from '@talentmesh/table';
import CandidateRowEntryDeleteButton from './CandidateRowEntryDeleteButton';
import CandidateRowEntryInternalBenchmarkBadge from './CandidateRowEntryInternalBenchmarkBadge';
import { CandidateRowEntry } from '@/Models/CandidateRowEntry';
import UIStrings from '@/Utils/UIStrings';

export default function createInviteCandidatesColumns(): MRT_ColumnDef<CandidateRowEntry>[] {
    return [
        {
            id: 'firstName',
            accessorKey: 'firstName',
            header: UIStrings.FirstName,
            size: 200,
            minSize: 200,
            maxSize: 200,
        },
        {
            id: 'lastName',
            accessorKey: 'lastName',
            header: UIStrings.LastName,
            size: 200,
            minSize: 200,
            maxSize: 200,
        },
        {
            id: 'email',
            accessorKey: 'email',
            header: UIStrings.Email,
            size: 300,
            minSize: 300,
            maxSize: 300,
        },
        {
            id: 'isInternal',
            accessorKey: 'isInternal',
            header: ' ',
            size: 147,
            minSize: 147,
            maxSize: 147,
            Cell: CandidateRowEntryInternalBenchmarkBadge,
        },
        {
            id: 'actions',
            header: ' ',
            columnDefType: 'display',
            Cell: CandidateRowEntryDeleteButton,
        },
    ];
}
